import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";

function UnsubscribeConfirmed() {
  return (
    <Layout>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="card shadow-sm">
              <div className="card-body text-center py-5">
                <div className="mb-4">
                  <i
                    className="bi bi-check-circle-fill text-success"
                    style={{ fontSize: "4rem" }}
                  ></i>
                </div>

                <h2 className="mb-3">Unsubscribe Successful</h2>

                <p className="lead mb-4">
                  You have been successfully unsubscribed from our marketing
                  emails.
                </p>

                <p className="text-muted mb-4">
                  We're sorry to see you go! You will no longer receive
                  promotional emails from WebVenly. Please note that you may
                  still receive important service-related communications if you
                  are a current customer.
                </p>

                <hr className="my-4" />

                <p className="mb-3">Changed your mind?</p>

                <div className="d-flex justify-content-center gap-3">
                  <Link to="/" className="btn btn-primary">
                    <i className="bi bi-house me-2"></i>
                    Go to Homepage
                  </Link>
                  <Link to="/contact" className="btn btn-outline-primary">
                    <i className="bi bi-envelope me-2"></i>
                    Contact Us
                  </Link>
                </div>

                <p className="mt-4 small text-muted">
                  If you unsubscribed by mistake or would like to resubscribe,
                  please <Link to="/contact">contact our support team</Link>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default UnsubscribeConfirmed;
